import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

export class PaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  firstPageLabel = `Primera página`;
  itemsPerPageLabel = `Items por página:`;
  lastPageLabel = `Última página`;

  nextPageLabel = `Siguiente`;
  previousPageLabel = `Atrás`;

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `Página (1) / 1 - 1 de ${length}`;
    }

    const accum = page * pageSize + 1;
    const accumEnd = accum + pageSize - 1;

    return `Página (${page + 1}) / ${accum} - ${accumEnd} de ${length}`;
  }
}
